<template>
  <div :class="{'modal-body': type === 'modal'}">
    <div class="registration-errors" v-show="errorMessage"><div class="alert alert-danger" v-html="errorMessage"></div></div>

    <div class="text-center">
      <button
        type="button"
        class="btn btn-xs btn-secondary"
        @click="onHandleClearSelections"
      ><i class="fa-regular fa-remove"></i> Clear Selections</button>
    </div>

    <validation-observer
      v-slot="{ invalid, valid, errors, handleSubmit, ...rest }"
      ref="agendaForm"
      id="agendaForm"
    >
      <div id="agenda-groups-wrapper" class="agenda-groups-wrapper">
        <form @submit.prevent="handleSubmit(submitAgendaForm)">
          <agenda-items
            :agenda="agenda"
          />
        </form>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {scrollToTop} from '../../helpers/scrollToTop'
import AgendaItems from './AgendaItems.vue'

export default {
  components: {AgendaItems},
  props: {
    type: {
      type: String,
      default: 'modal'
    }
  },
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "slug",
      "errorMessage",
      "agenda"
    ])
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions('basketStore', ['updateAgendaGroups']),

    onHandleClearSelections() {
      this.$nextTick(() => {
        this.agenda.groups.forEach(group => {
          group.sessions.forEach(session => {
            session.selected = null;
          });
        });
      });
    },

    submitForm: async function() {
      this.$refs.agendaForm.handleSubmit(this.submitAgendaForm);
    },

    submitAgendaForm: async function () {
      const sessions = [];

      this.agenda.groups.forEach(group => {
        group.sessions.forEach(session => {
          if (session.selected) {
            sessions.push(+session.selected);
          }
        });
      });

      const data = {
        sessions: sessions,
        success: () => {
          this.$nextTick(() => {
            // this.$refs.attendeesForm.reset();
          });
          // go to next step
          if (this.type === 'modal') {
            this.$store.dispatch('basketStore/changeStep', { type: "forward" });
          } else if (this.type === 'page') {
            //TODO: redirect to success page
          }
        },
        error: (err) => {
          if (err.errors) {
            scrollToTop('.modal-body');
            this.$refs.agendaForm.setErrors(err.errors);
          }
        }
      };

      this.$refs.agendaForm.validate().then(success => {
        if (!success) {
          return
        }

        this.updateAgendaGroups(data)
          .then(() => {});
      });
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .app-checkbox div {
  font-weight: 400;
}

::v-deep .fv-help-block {
  font-family: sans-serif;
  font-weight: 700;
  color: #dc3545 !important;
  font-size: 16px;
}
</style>
